import classes from "./Contact.module.css";
import { IconContext } from "react-icons";
import { FiPhone } from "react-icons/fi";
import { HiOutlineMail } from "react-icons/hi";
import { GoLocation } from "react-icons/go";
import { FaWhatsapp } from "react-icons/fa";
import ContactInput from "./ContactInput";

const Contact = () => {
  const iconsStyles = {
    size: "2rem",
    color: "var(--first-color)",
  };

  const handleWhatsAppClick = () => {
    const phoneNumber = "+573002515632";
    const message = "Hola! Me gustaría contactarte sobre tu trabajo.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <IconContext.Provider value={iconsStyles}>
      {/* <div className={classes.header}>
        <h1>Contact Me</h1>
        <h5>Get in touch</h5>
      </div> */}
      <div className={classes.main_container}>
        <div className={classes.data_container}>
          <div>
            <div className={classes.icon_container}>
              <FiPhone />
            </div>
            <div className={classes.text_container}>
              <h2>Celular</h2>
              <h5>+57 300 251 5632</h5>
            </div>
          </div>
          <div>
            <div className={classes.icon_container}>
              <HiOutlineMail />
            </div>
            <div className={classes.text_container}>
              <h2>Email</h2>
              <h5>alejandroTPD@hotmail.com</h5>
            </div>
          </div>
          <div>
            <div className={classes.icon_container}>
              <GoLocation />
            </div>
            <div className={classes.text_container}>
              <h2>Localizacion</h2>
              <h5>Bogotá - Colombia</h5>
            </div>
          </div>
          <div
            className={classes.whatsapp_container}
            onClick={handleWhatsAppClick}
          >
            <div className={classes.icon_container}>
              <FaWhatsapp />
            </div>
            <div className={classes.text_container}>
              <h2>WhatsApp</h2>
              <h5>+57 300 251 5632</h5>
            </div>
          </div>
        </div>
        {/* <ContactInput /> */}
      </div>
    </IconContext.Provider>
  );
};

export default Contact;
